import { withInstall, withInstallDirective } from '@bigin/utils'

import Popover from './src/popover.vue'
import PopoverDirective, { VPopover } from './src/directive'

export const BPopoverDirective = withInstallDirective(
  PopoverDirective,
  VPopover
)

export const BPopover = withInstall(Popover, {
  directive: BPopoverDirective,
})
export default BPopover

export * from './src/popover'
